import pick from 'lodash/pick';

import { SINGLE_CARD_FETCH_SUCCEEDED } from '../redux/singleCard';

import type {
  EventTracking,
  SingleCardSucceededTracker,
  SingleCardSucceeded,
  SingleCardTrackingState,
} from '../types';

// Note we are not using ActionWithPayload here;
//
// That's ok because Action < ActionWithPayload, and
// Action always has a subset of ActionWithPayload's variables.

function singleCardFetchSucceeded(
  action: SingleCardSucceeded,
  state: SingleCardTrackingState,
): SingleCardSucceededTracker {
  const data = pick(state.singleCard.data, [
    'name',
    'coins',
    'eventType',
    'partner.name',
    'images',
  ]);

  return {
    id: state.singleCard.data.id,
    singleCard: data,
  };
}

/** @type {ActionType} */
export const pbr_single_card_fetch_succeeded =
  'pbr_single_card_fetch_succeeded';

// Make sure you cast this before you export it in your duckling;
// we have to verify type BEFORE we leave the execution context of this module.
//
// The best way to do this is actually to create the object
// and do each assignment individually... for now.

const tracking: EventTracking = {};
tracking[SINGLE_CARD_FETCH_SUCCEEDED] = singleCardFetchSucceeded;

export default tracking;
